import axios from "axios";
import Config from "../utils/Config";

class PolicyService {
  getAuthHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("trp_agt_tk")}`,
      },
    };
  }

  async getPolicies() {
    try {
      const response = await axios.get(
        `${Config.apiUrl}/get/policy`,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message: response.data.data?.reason || "Policies fetched successfully",
        data: response.data.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          "An error occurred while getting policies",
        data: null,
      };
    }
  }

  async getTripSecureInsurancePolicies(policy_type = null) {
    try {
      const endpoint = policy_type
        ? `${Config.apiUrl}/policy/get/tripsecure_insurance/${policy_type}`
        : `${Config.apiUrl}/policy/get/tripsecure_insurance`;

      const response = await axios.get(endpoint, this.getAuthHeaders());
      return {
        status: true,
        message:
          response.data.data?.reason ||
          "TripSecure insurance policies fetched successfully",
        data: response.data.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          "An error occurred while getting TripSecure insurance policies",
        data: null,
      };
    }
  }

  async getGeneralInsurancePolicies(policy_type = null) {
    try {
      const endpoint = policy_type
        ? `${Config.apiUrl}/policy/get/general_insurance/${policy_type}`
        : `${Config.apiUrl}/policy/get/general_insurance`;

      const response = await axios.get(endpoint, this.getAuthHeaders());
      return {
        status: true,
        message:
          response.data?.reason ||
          "General insurance policies fetched successfully",
        data: response.data.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.reason ||
          "An error occurred while getting general insurance policies",
        data: null,
      };
    }
  }

  async getTravelInsurancePolicies() {
    try {
      const response = await axios.get(
        `${Config.apiUrl}/policy/get/travel_insurance/travel_insurance`,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message:
          response.data?.reason ||
          "Travel insurance policies fetched successfully",
        data: response.data.data
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.reason ||
          "An error occurred while getting travel insurance policies",
        data: null,
      };
    }
  }

  async getLifeInsurancePolicies() {
    try {
      const response = await axios.get(
        `${Config.apiUrl}/policy/get/life_insurance/life_insurance`,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message:
          response.data?.reason ||
          "Life insurance policies fetched successfully",
        data: response.data.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.reason ||
          "An error occurred while getting life insurance policies",
        data: null,
      };
    }
  }

  async purchasePolicy(payload, policy_slug) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/agent/policy/purchase/${policy_slug}`,
        payload,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message: response.data.data?.reason || "Policy purchased successfully",
        data: response.data.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          "An error occurred while purchasing policy",
        data: null,
      };
    }
  }
}

const policyService = new PolicyService();
export default policyService;

